class AnnouncementMarquee extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.announcement-marquee__track');
    this.sets = Array.from(this.querySelectorAll('[data-marquee-set]'));
    if (!this.track || this.sets.length < 2) return;

    // Respect reduced-motion: the CSS already disables the animation, and there
    // is no point cloning content that never scrolls.
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    this.baseHTML = this.sets[0].innerHTML;
    this.speed = parseFloat(this.dataset.speed) || 25;
    this.baseWidth = this.sets[0].scrollWidth; // width of one server-rendered copy
    this.lastCopies = 1;
    this.lastWidth = 0;

    this.build = this.build.bind(this);
    this.schedule = this.schedule.bind(this);

    this.build();

    // Fonts change measured width; re-measure once they're ready.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        this.baseWidth = 0;
        this.build();
      });
    }

    this.resizeObserver = new ResizeObserver(this.schedule);
    this.resizeObserver.observe(this);
  }

  disconnectedCallback() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
    cancelAnimationFrame(this.raf);
  }

  schedule() {
    // Coalesce resize bursts into a single rAF-timed rebuild.
    cancelAnimationFrame(this.raf);
    this.raf = requestAnimationFrame(this.build);
  }

  build() {
    const containerWidth = this.clientWidth;
    if (!containerWidth) return;

    // Skip work when nothing that affects the layout actually changed.
    if (containerWidth === this.lastWidth && this.baseWidth) return;
    this.lastWidth = containerWidth;

    // Re-measure a single copy only when needed (first run / after fonts load).
    if (!this.baseWidth) {
      this.sets[0].innerHTML = this.baseHTML;
      this.lastCopies = 1;
      this.baseWidth = this.sets[0].scrollWidth;
      if (!this.baseWidth) return;
    }

    // Repeat the copy so one set always spans at least the viewport (+1 spare),
    // otherwise the -50% shift would expose empty space on the right.
    const copies = Math.max(1, Math.ceil(containerWidth / this.baseWidth) + 1);

    if (copies !== this.lastCopies) {
      const filled = new Array(copies).fill(this.baseHTML).join('');
      this.sets.forEach((set) => {
        set.innerHTML = filled;
      });
      this.lastCopies = copies;
    }

    // Keep a constant scroll speed (px/second) from the merchant's duration
    // setting. Derived arithmetically to avoid a second forced layout read.
    const setWidth = this.baseWidth * this.lastCopies;
    const pxPerSecond = 2400 / this.speed;
    this.track.style.animationDuration = setWidth / pxPerSecond + 's';
  }
}

customElements.define('announcement-marquee', AnnouncementMarquee);
